import { UpperCasePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { UserWithKpis } from '@core/interfaces/kpis.interface'
import { ScoreComponent } from '../score/score.component'
import { KpiDetailsComponent } from '../kpi-details/kpi-details.component'
import { IconComponent } from '../icons/icons.component'

@Component({
  selector: 'kpis-card',
  imports: [ScoreComponent, UpperCasePipe, RouterLink, KpiDetailsComponent, IconComponent],
  templateUrl: './kpis-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpisCardComponent {
  user = input.required<UserWithKpis>()

  link = input<string[]>()
  showAvatar = input<boolean>(true)
}
